import React from "react";
import styled from "styled-components";

import iconFlag from "assets/icons/icon_flag_blue.svg";
import SettingIcon from "assets/icons/icon_setting.svg";

const CenterListCard = ({
  partnerInfo,
  isSetting,
  onClickBranch,
  onClickSetting,
}) => {
  let updatePartnerInfo = { ...partnerInfo };
  if (partnerInfo.headquarterYn === "Y" && partnerInfo.seqPartnerBranch === 0) {
    updatePartnerInfo["seqPartner"] = partnerInfo.beforeSeqPartner;
    updatePartnerInfo["seqPartnerBranch"] = partnerInfo.beforeSeqPartnerBranch;
  }
  return (
    <Wrapper>
      <div className="middle">
        <ul>
          {updatePartnerInfo.partnerList.map((v) => {
            return (
              <li key={v.seqPartner}>
                <div
                  className={
                    v.branchUseYn === "N" &&
                    v.seqPartner === updatePartnerInfo.seqPartner
                      ? "main"
                      : undefined
                  }
                >
                  <a
                    onClick={() => {
                      if (
                        v.branchUseYn === "N" &&
                        v.seqPartner !== updatePartnerInfo.seqPartner &&
                        isSetting
                      ) {
                        onClickBranch({
                          partner: v.partnerName,
                          seqPartner: v.seqPartner,
                          seqPartnerBranch: v.seqPartnerBranch,
                        });
                      }
                    }}
                  >
                    <img
                      src={
                        v.imageUrl ||
                        `/static/media/default_partner_thumbnail.64f3cf87.svg`
                      }
                    />
                    <span>{v.partnerName}</span>
                  </a>
                  {v.branchUseYn === "N" && isSetting && (
                    <div
                      onClick={() =>
                        onClickSetting({
                          partner: v.partnerName,
                          seqPartner: v.seqPartner,
                          seqPartnerBranch: v.seqPartnerBranch,
                          headOfficeManagerYn: v.headOfficeManagerYn,
                        })
                      }
                    >
                      <img src={SettingIcon} width="24px" height="24px" />
                    </div>
                  )}
                </div>
                {v.partnerBranches.length > 0 && (
                  <ul>
                    {v.partnerBranches.map((pb) => {
                      return (
                        <li
                          key={pb.seqPartnerBranch}
                          className={
                            pb.seqPartnerBranch ===
                            updatePartnerInfo.mainSeqPartnerBranch
                              ? "main"
                              : undefined
                          }
                        >
                          <a
                            onClick={() => {
                              if (
                                pb.seqPartnerBranch !==
                                  updatePartnerInfo.mainSeqPartnerBranch &&
                                isSetting
                              ) {
                                onClickBranch({
                                  partner: v.partnerName,
                                  partnerBranch: pb.partnerName,
                                  seqPartner: v.seqPartner,
                                  seqPartnerBranch: pb.seqPartnerBranch,
                                });
                              }
                            }}
                          >
                            {pb.partnerName}
                          </a>
                          {isSetting && (
                            <div
                              onClick={() =>
                                onClickSetting({
                                  partner: v.partnerName,
                                  partnerBranch: pb.partnerName,
                                  seqPartner: v.seqPartner,
                                  seqPartnerBranch: pb.seqPartnerBranch,
                                  headOfficeManagerYn: v.headOfficeManagerYn,
                                })
                              }
                            >
                              <img
                                src={SettingIcon}
                                width="24px"
                                height="24px"
                              />
                            </div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .middle {
    margin: 0 -20px;
    font-weight: 600;
  }
  .middle > ul {
    padding: 0 24px;
  }

  .middle ul {
    display: flex;
    flex-wrap: wrap;
  }
  .middle ul li {
    width: 100%;
  }
  .middle ul div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .middle ul div.main a:after {
    content: "";
    display: inline-flex;
    margin-left: 12px;
    width: 20px;
    height: 20px;
    background: url(${iconFlag}) no-repeat center center / 20px;
  }
  .middle ul li a {
    flex: 1;
    margin-right: 20px;
    display: flex;
    align-items: center;
    padding: 8px 0;
  }

  .middle ul li a img {
    margin-right: 10px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .middle ul li li a {
    padding: 12px;
  }
  .middle ul li.disabled span {
    opacity: 0.33;
  }
  .middle ul li.setting > a {
    background: url(${SettingIcon}) no-repeat right center / 24px;
  }
  .middle ul li.main a:after {
    content: "";
    display: inline-flex;
    margin-left: 12px;
    width: 20px;
    height: 20px;
    background: url(${iconFlag}) no-repeat center center / 20px;
  }
  .middle ul li.all {
    display: none;
  }
  .middle ul li.all a:before {
    content: "전체";
    display: inline-flex;
    margin-right: 6px;
    padding: 2px 7px;
    background-color: var(--blue);
    border-radius: 6px;
    font-size: 12px;
    color: white;
  }
  &.all .middle ul li.all {
    display: block;
  }

  .middle ul ul {
    position: relative;
    padding-left: 38px;
  }
  .middle ul ul:before {
    content: "";
    position: absolute;
    left: 20px;
    top: 10px;
    bottom: 10px;
    border-right: 2px solid #f0f3f9;
  }
  .middle ul ul li {
    order: 1;

    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .middle ul ul li a {
    flex: 1;
    margin-right: 20px;
  }
  .middle ul ul li.disabled {
    order: 2;
  }
`;

export default CenterListCard;
